/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-04-14 15:25:39
 */
import { getTenantId, getToken } from "../auth";
import { assembleWSUrl } from "../urlUtil";
import BaseClient from "./baseClient";
import Message from "./message";
import Order from "./order";

const CAT_WS_URL = "/cat/ws";

class CATClient extends BaseClient {
    constructor(parameters) {
        const catUrl = assembleWSUrl(CAT_WS_URL) + `?tId=${getTenantId()}`;
        super(catUrl,getToken(), parameters);
    }

    occupy(userId, observingRangeId, taskExclusiveId, groupKey, replacedId) {
        return this._sendWrapper("occupy", {
            userId,
            observingRangeId,
            taskExclusiveId,
            groupKey,
            replacedId,
        });
    }

    observe(userId, groupKeys) {
        return this._sendWrapper("observe", { userId, groupKeys });
    }

    getLock(segmentId, version) {
        return this._sendWrapper("getLock", { id: segmentId, ver: version });
    }

    releaseLock(segmentId) {
        return this._sendWrapper("releaseLock", { segmentId });
    }

    beginBatch() {
        return this._sendWrapper("batchActionStart");
    }

    endBatch(sID) {
        return this._sendWrapper("batchActionEnd", { sID });
    }

    updateSegment(segmentUpdateFormData) {
        return this._sendWrapper("updateSegment", segmentUpdateFormData);
    }
    checkQA(checkFormData) {
        return this._sendWrapper("qaCheck", checkFormData);
    }
    editSrc(formData) {
        return this._sendWrapper("srcEdit", formData);
    }
    combineSentence(formData) {
        return this._sendWrapper("sentenceCombine", formData);
    }
    splitSentence(formData) {
        return this._sendWrapper("sentenceSplit", formData);
    }
    getAutoFillResult(formData) {
        return this._sendWrapper("fillTag", formData);
    }
    previewFile(formData) {
        return this._sendWrapper("preview", formData);
    }

    _sendWrapper(name, data) {
        let res;
        try {
            res = this._send(new Order(name, data));
            return res;
        } catch (error) {
            if (error instanceof Message) {
                throw error.msg;
            } else {
                throw "" + error;
            }
        }
    }
}

export default CATClient;
